import Cookies from 'js-cookie';

export const setCookie = (name: string, value: string, days = 7) => {
  const consent = Cookies.get('cookie_consent');
  if (consent === 'accepted') {
    Cookies.set(name, value, { expires: days, sameSite: 'strict' });
  }
};

export const getCookie = (name: string) => {
  const consent = Cookies.get('cookie_consent');
  if (consent === 'accepted' || name === 'cookie_consent') {
    return Cookies.get(name);
  }
  return null;
};

export const removeCookie = (name: string) => {
  Cookies.remove(name);
};